import type { StyleFunctionProps } from '@chakra-ui/styled-system'
import { mode } from '@chakra-ui/theme-tools'

const styles = {
  global: (props: StyleFunctionProps) => ({
    body: {
      bg: mode("#fffff", "#121212")(props),
      color: mode("#121212", "#fffff")(props),
      transitionProperty: 'background-color',
      transitionDuration: '500ms',
      transitionTimingFunction: 'ease-in-out',
    },
    a: {
      _hover: {
        textDecoration: 'none',
        // color: props.colorMode === 'light' ? "#005050" : "#005050",
      },
    },
  }),
}

export default styles
